import React from 'react';
import { useAuth } from '../contexts/global/AuthContext';
import { useTheme } from '../contexts/global/ThemeContext';

// This component demonstrates GLOBAL context usage
// It needs auth state and theme state that are used app-wide

export function Header() {
  const { user, logout } = useAuth(); // Global - user info needed in header
  const { theme, toggleTheme } = useTheme(); // Global - theme affects entire UI

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="app-title">📋 Todo Context Demo</h1>
          <span className="context-indicator">
            🌐 Uses GLOBAL contexts
          </span>
        </div>
        
        <div className="header-right">
          {/* Theme toggle - uses GLOBAL theme context */}
          <button 
            onClick={toggleTheme}
            className="theme-toggle"
            title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
          >
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
          
          {/* User info - uses GLOBAL auth context */}
          {user && (
            <div className="user-info">
              <span className="user-greeting">Hello, {user.name}!</span>
              <button onClick={logout} className="logout-btn">
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
      
      <style>{`
        .header {
          background: ${theme === 'dark' ? '#2d3748' : '#ffffff'};
          color: ${theme === 'dark' ? '#ffffff' : '#2d3748'};
          border-bottom: 1px solid ${theme === 'dark' ? '#4a5568' : '#e2e8f0'};
          padding: 1rem;
          margin-bottom: 2rem;
          position: sticky;
          top: 0;
          z-index: 1000;
        }
        
        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 1200px;
          margin: 0 auto;
        }
        
        .header-left {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        .app-title {
          font-size: 1.5rem;
          font-weight: bold;
          margin: 0;
        }
        
        .context-indicator {
          background: #059669;
          color: white;
          padding: 0.25rem 0.5rem;
          border-radius: 0.25rem;
          font-size: 0.75rem;
        }
        
        .header-right {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        .theme-toggle {
          background: ${theme === 'dark' ? '#4a5568' : '#f7fafc'};
          border: 1px solid ${theme === 'dark' ? '#6b7280' : '#d1d5db'};
          color: ${theme === 'dark' ? '#ffffff' : '#374151'};
          padding: 0.5rem;
          border-radius: 0.375rem;
          cursor: pointer;
          font-size: 1.25rem;
        }
        
        .theme-toggle:hover {
          background: ${theme === 'dark' ? '#6b7280' : '#e5e7eb'};
        }
        
        .user-info {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        .user-greeting {
          font-weight: 500;
        }
        
        .logout-btn {
          background: #dc2626;
          color: white;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          cursor: pointer;
          font-size: 0.875rem;
        }
        
        .logout-btn:hover {
          background: #b91c1c;
        }
      `}</style>
    </header>
  );
}
